import styled from 'styled-components';

export const Wrapper = styled.div`
.scrollButton{
    position: fixed;
    bottom: 170px;
    right: 20px;
    transition: 'opacity 0.3s ease-in-out',
}
.scollText
{
    position: fixed;
    bottom: 150px;
    right: 20px;
    color:blue;
    transition: 'opacity 0.3s ease-in-out',
    font-family: 'Noto Sans', sans-serif;
}
`;
